var React = require('react');

function NavIconsApplications (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m12 2.18-9.3 4.12v11.24l9.3 4.28 9.31-4.26v-11.24zm0 1.16 7.22 3.27-2.68 1.16-7.26-3.2zm-.53 17.1-7.7-3.61v-9.5l7.69 3.33zm-6.68-13.85 3.26-1.47 7.18 3.21-3.23 1.39zm15.44 10.26-7.71 3.59v-9.78l7.71-3.31zm-2.5-6.71-2.73 1.16v1.16l2.69-1.15v-1.17z"}));
}

NavIconsApplications.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = NavIconsApplications;

NavIconsApplications.default = NavIconsApplications;
